export default "__VITE_ASSET__V40_2UKz__"